module.exports = __webpack_public_path__ + "static/img/CommLabor.e5609f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CommLabor.jpg
// module id = 4hPw
// module chunks = 0